// Turning stored availability into something a patient reads.
//
// A band is `{dayOfWeek, startMinute, endMinute}` where the minutes count from
// local midnight. NO band at all means "any day, any time" — that is a correct
// reading of an empty set, not missing data, and it is the commonest request.
// Saying "no availability" there would be exactly backwards.

const DAY_NAMES = [
  "Sunday",
  "Monday",
  "Tuesday",
  "Wednesday",
  "Thursday",
  "Friday",
  "Saturday",
];

/** 540 -> "9:00 AM". 1440 is midnight at the END of the day, and is real. */
export function formatMinute(minute) {
  // `Number(null)` is 0, which is finite and would render as "12:00 AM" — a
  // concrete time standing in for a missing one. An absent minute has to read
  // as absent, or a band with a broken edge silently claims midnight.
  if (minute === null || minute === undefined || minute === "") return "";
  const total = Number(minute);
  if (!Number.isFinite(total)) return "";
  if (total >= 1440) return "midnight";

  const hour24 = Math.floor(total / 60);
  const minutes = total % 60;
  const suffix = hour24 < 12 ? "AM" : "PM";
  const hour12 = hour24 % 12 === 0 ? 12 : hour24 % 12;
  return `${hour12}:${String(minutes).padStart(2, "0")} ${suffix}`;
}

export function describeBand(band) {
  const day = DAY_NAMES[band?.dayOfWeek] || "";
  const from = formatMinute(band?.startMinute);
  const to = formatMinute(band?.endMinute);
  if (!day) return "";
  // A band covering the whole day says so, rather than "12:00 AM to midnight".
  if (band.startMinute === 0 && band.endMinute >= 1440) return `${day}, any time`;
  return `${day} ${from} - ${to}`;
}

export function describeBands(bands) {
  if (!Array.isArray(bands) || bands.length === 0) return "Any day, any time";
  return bands.map(describeBand).filter(Boolean).join(" · ");
}

export {DAY_NAMES};
